import React from "react";
import getGoogleMapsLink from "./../../utilities/maps";
import { formatDateString } from "./../../utilities/datesFormatter";

export const linkToGoogleMaps = (tableInfo, event) => {
  if (tableInfo && tableInfo.column) {
    let ubicacion;
    switch (tableInfo.column.id) {
      case "Inicio":
        ubicacion = tableInfo.original.UbicacionInicio;
        window.open(
          getGoogleMapsLink(ubicacion.Latitud, ubicacion.Longitud, "_blank")
        );
        break;
      case "Fin":
        ubicacion = tableInfo.original.UbicacionFin;
        window.open(
          getGoogleMapsLink(ubicacion.Latitud, ubicacion.Longitud, "_blank")
        );
        break;
      case "Mapa":
        ubicacion = tableInfo.original;
        window.open(
          getGoogleMapsLink(ubicacion.Latitud, ubicacion.Longitud, "_blank")
        );
        break;
      default:
        break;
    }
  }
};

export const buildTripsTableColumns = lang => {
  const tripsTableColumns = [
    {
      Header: lang.Trayecto,
      accessor: "Trayecto"
    },
    {
      Header: lang.Unidad,
      accessor: "Unidad"
    },
    {
      Header: lang.Inicio,
      accessor: "Inicio",
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {formatDateString(props.value)}
        </span>
      )
    },
    {
      Header: lang.Fin,
      accessor: "Fin",
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {formatDateString(props.value)}
        </span>
      )
    },
    {
      Header: lang.Impacto,
      accessor: "Impacto",
      Cell: props =>
        props.value === true ? (
          <img
            src="https://apps.zeekgps.com/alpha/images/139.svg"
            alt={lang.Impacto}
          />
        ) : (
          ""
        ),
      filterMethod: (input, data) => {
        if (input.value.length) {
          return data.Impacto;
        }
        return true;
      }
    },
    {
      Header: lang.Colision,
      accessor: "Colision",
      Cell: props =>
        props.value === true ? (
          <img
            src="https://apps.zeekgps.com/alpha/images/140.svg"
            alt={lang.Colision}
          />
        ) : (
          ""
        ),
      filterMethod: (input, data) => {
        if (input.value.length) {
          return data.Colision;
        }
        return true;
      }
    },
    {
      Header: lang.Puntos,
      accessor: "Puntos"
    }
  ];

  return tripsTableColumns;
};

export const buildEventsTableColumns = lang => {
  const eventsColumns = [
    {
      Header: lang.Icono,
      accessor: "ImagenUrl",
      Cell: props => <img src={props.value} alt="" />,
      filterable: false
    },
    {
      Header: lang.Evento,
      accessor: "NombreEvento"
    },
    {
      Header: lang.Unidad,
      accessor: "Unidad"
    },
    {
      Header: lang.Fecha,
      accessor: "FechaEvento"
    },
    {
      Header: lang.Puntos,
      accessor: "Puntos"
    },
    {
      Header: lang.Detalles,
      accessor: "Detalle"
    },
    {
      Header: lang.Mapa,
      accessor: "Mapa",
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {lang.Mapa}
        </span>
      )
    }
  ];

  return eventsColumns;
};

export const buildAnalysisByUnitTableColumns = lang => {
  const eventsColumns = [
    {
      Header: lang.Unidad,
      accessor: "Descripcion"
    },
    {
      Header: lang.ExcesosVelocidad,
      accessor: "ExcesosVelocidad"
    },
    {
      Header: lang.AceleracionesIntensas,
      accessor: "AceleracionesIntensas"
    },
    {
      Header: lang.FrenadosIntensos,
      accessor: "FrenadosIntensos"
    },
    {
      Header: lang.GirosBruscos,
      accessor: "GirosBruscos"
    },
    {
      Header: lang.Impactos,
      accessor: "Impactos"
    },
    {
      Header: lang.Colisiones,
      accessor: "Colisiones"
    },
    {
      Header: lang.Ralenti,
      accessor: "Ralenties"
    },
    {
      Header: lang.Trayectos,
      accessor: "Trayectos"
    },
    {
      Header: lang.Distancia,
      accessor: "DistanciaRecorrida"
    },
    {
      Header: lang.Puntos,
      accessor: "Puntos",
      Cell: props => <span className="points-bold"> {props.value} </span>
    }
  ];

  return eventsColumns;
};



// WEBPACK FOOTER //
// ./src/containers/Driving/builders.js